<template>
  <div class="wt2-publish-url" :class="[{ '-no-arrow': !showArrow }]">
    <wt-close v-if="showCloseIcon" @click.stop.native="close"></wt-close>
    <span class="wt2-text-s wt2-color-disabled">Link copied!</span>
    <slot></slot>
    <span class="-ok wt2-text-m wt2-color-primary" @click.stop="close">OK</span>
  </div>
</template>

<script>
export default {
  props: {
    showCloseIcon: {
      type: Boolean,
      default: true,
    },

    showArrow: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
